module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ByteTrackers - Digital Transformation & Software Solutions","short_name":"ByteTrackers","start_url":"/","background_color":"#ffffff","theme_color":"#1386ef","display":"minimal-ui","icon":"src/assets/img/logo/favicon.svg","description":"Transform your business with ByteTrackers - Leading experts in digital transformation, software development, and innovative technology solutions.","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ba975b2f63ddff24afee67f3ddb4f6f1"},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
